import { apiRequest } from "./apiClient";

export const submitFeedback = async ({ category, description }) => {
  return apiRequest({
    method: "POST",
    endpoint: "/feedback",
    body: { category, description },
  });
};
